import React from 'react';
import ButtonTogglePlay from './ButtonTogglePlay';
import CheckboxToggleRepeatMode from './CheckboxToggleRepeatMode';
import InputDuration from './InputDuration';
import InputCurrentTime from './InputCurrentTime';
import ControlBar from './ControlBar';
import Spacer from './Spacer';
import InputsContainer from './InputsContainer';
import InputContainer from './InputContainer';
import Clock from './Clock';

const PlaybackControls = () => (
  <ControlBar>
    <ButtonTogglePlay />
    <Spacer />
    <CheckboxToggleRepeatMode />
    <InputsContainer>
      <Clock />
      Time
      <InputContainer>
        <InputCurrentTime />
      </InputContainer>
      Duration
      <InputContainer>
        <InputDuration />
      </InputContainer>
    </InputsContainer>
  </ControlBar>
);

export default PlaybackControls;
